var map = {
	"./login/controller.js": 95654,
	"./premarket/controller.js": 3474,
	"./register/controller.js": 13416,
	"./reset-password/controller.js": 25062,
	"./set-password/controller.js": 14413,
	"./verify/controller.js": 73408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18144;